import { useGetBotbPassMembersDataQuery } from "@/app/redux/features/api/membersHome";
import { useGetSubscriptionLobbyContentQuery } from "@/app/redux/features/api/common";
import Markdown from "react-markdown";

export default function ExclusiveBanner({ fullWidth = false }: { fullWidth?: boolean }) {
  const { data: lobbyContent } = useGetSubscriptionLobbyContentQuery();
  const { data: membersData } = useGetBotbPassMembersDataQuery();

  return (
    <div className={`w-full flex justify-center ${fullWidth ? "px-4 lg:px-12" : "px-[18px]"}`}>
      <div
        className={`w-full overflow-hidden p-4 flex flex-col gap-3 lg:gap-4 bg-[linear-gradient(59.4deg,#d7185d_12.8%,#24339f_86.3%)] ${
          fullWidth
            ? "rounded-lg lg:rounded-none lg:flex-row lg:items-center lg:justify-between lg:p-8"
            : "max-w-[518px] rounded-lg"
        }`}>
        <div className={`flex flex-col gap-1.5 lg:gap-2 ${fullWidth ? "lg:min-w-0 lg:flex-1" : ""}`}>
          <p className="m-0 p-0 text-[16px] lg:text-[18px] font-bold font-jost leading-[22px] lg:leading-6 text-white tracking-[0]">
            <Markdown
              components={{
                strong: props => <span className="text-[#D4F400]">{props.children}</span>,
              }}>
              {membersData?.MemberMainTitle}
            </Markdown>
          </p>
          <p className="m-0 p-0 text-[13px] lg:text-[14px] font-normal font-jost leading-[18px] lg:leading-5 text-white/70 tracking-[0]">
            {membersData?.MemberMainDescription}
          </p>
        </div>

        <div className="flex lg:hidden items-center gap-2">
          <p className="m-0 p-0 text-[8px] font-medium font-jost leading-3 text-white/40 uppercase whitespace-nowrap tracking-[0]">
            Subscribers competitions stats
          </p>
          <div className="flex-1 h-px bg-white/20" />
        </div>

        <div
          className={`flex items-center justify-evenly gap-4 w-full ${
            fullWidth ? "lg:w-auto lg:justify-end lg:gap-8 lg:shrink-0" : ""
          }`}>
          <div className="flex gap-1 lg:gap-[5px] items-center shrink-0">
            <div className="opacity-30 lg:opacity-60 size-6 lg:size-8 flex items-center justify-center shrink-0">
              <svg
                className="size-[18px] lg:size-6"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true">
                <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
                <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
                <path d="M4 22h16" />
                <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22" />
                <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22" />
                <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z" />
              </svg>
            </div>
            <div className="flex flex-col">
              <p className="m-0 p-0 text-[12px] lg:text-[14px] font-bold font-jost leading-4 lg:leading-5 text-white tracking-[0]">
                {lobbyContent?.totalWinnerCount || "—"}
              </p>
              <p className="m-0 p-0 text-[10px] lg:text-[13px] font-medium font-jost leading-3 lg:leading-[18px] text-white/60 whitespace-nowrap tracking-[0]">
                Winners
              </p>
            </div>
          </div>

          <div className="w-px h-6 bg-white/30 shrink-0" aria-hidden="true" />

          <div className="flex gap-1 lg:gap-[5px] items-center shrink-0">
            <div className="opacity-30 lg:opacity-60 size-6 lg:size-8 flex items-center justify-center shrink-0">
              <svg
                className="size-5 lg:size-[27px]"
                viewBox="0 0 26.667 26.667"
                fill="none"
                stroke="white"
                strokeWidth="1.333"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true">
                <path d="M12.502 10.353l-1.545.76.295-1.609-1.252-1.14 1.728-.234.772-1.463.773 1.463 1.728.234-1.252 1.14.295 1.609z" />
                <path d="M22.097 16.528v5.855l-8.837 3.458-8.836-3.458v-5.826" />
                <path d="M22.096 11.028l3.119 4.158-8.837 3.379-3.119-4.158" />
                <path d="M4.425 11.028L1.306 15.186l8.837 3.379 3.119-4.158" />
                <path d="M13.326 24.831V15.03" />
                <path d="M8.354 9.523L4.424 11.027l8.836 3.334 8.837-3.334-3.9-1.475" />
                <path d="M17.623 5.691l-2.06.976.393-2.068-1.669-1.464 2.303-.301 1.03-1.881 1.03 1.881 2.303.301-1.669 1.464.393 2.068z" />
              </svg>
            </div>
            <div className="flex flex-col">
              <p className="m-0 p-0 text-[12px] lg:text-[14px] font-bold font-jost leading-4 lg:leading-5 text-white tracking-[0]">
                {lobbyContent?.totalPrizeCount || "—"}
              </p>
              <p className="m-0 p-0 text-[10px] lg:text-[13px] font-medium font-jost leading-3 lg:leading-[18px] text-white/60 whitespace-nowrap tracking-[0]">
                Prizes given
              </p>
            </div>
          </div>

          <div className="w-px h-6 bg-white/30 shrink-0" aria-hidden="true" />

          <div className="flex gap-1 lg:gap-[5px] items-center shrink-0">
            <div className="opacity-30 lg:opacity-60 size-6 lg:size-8 flex items-center justify-center shrink-0">
              <svg
                className="size-[18px] lg:size-6"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true">
                <path d="M12 8v13" />
                <path d="M12 8c-.362-1.49-.985-2.765-1.787-3.657C9.41 3.452 8.465 2.984 7.5 3a2.5 2.5 0 000 5" />
                <path d="M12 8c.362-1.49.985-2.765 1.787-3.657.803-.892 1.748-1.36 2.713-1.343a2.5 2.5 0 010 5" />
                <path d="M19 12v7a2 2 0 01-2 2H7a2 2 0 01-2-2v-7" />
                <path d="M3 9a1 1 0 011-1h16a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V9z" />
              </svg>
            </div>
            <div className="flex flex-col">
              <p className="m-0 p-0 text-[12px] lg:text-[14px] font-bold font-jost leading-4 lg:leading-5 text-white tracking-[0]">
                {lobbyContent?.totalPrizeValue || "—"}
              </p>
              <p className="m-0 p-0 text-[10px] lg:text-[13px] font-medium font-jost leading-3 lg:leading-[18px] text-white/60 whitespace-nowrap tracking-[0]">
                Won
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
